import "../css/styles.css";
import setupHamburgerMenu from "./hamburger.js";
import setupI18n from "./i18n.js";

setupHamburgerMenu();
setupI18n();
